import { Header } from './primitives/Header';

function ArticleTitle({ title }) {
  return <Header>{title}</Header>;
}

ArticleTitle.propTypes = { title: PropTypes.string.isRequired };

export default ArticleTitle;
